import React from 'react';
import { User, Building2 } from 'lucide-react';

export function AccountTypeSelector({ onSelectType }) {
  return (
    <div className="space-y-3">
      <button
        onClick={() => onSelectType('single')}
        className="w-full text-left p-4 border-2 border-slate-200 rounded-sm hover:border-[#0047AB] hover:bg-[#EFF6FF] transition-all group"
        data-testid="account-type-single"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-slate-100 group-hover:bg-[#0047AB]/10 rounded-sm flex items-center justify-center shrink-0 transition-colors">
            <User className="w-5 h-5 text-slate-600 group-hover:text-[#0047AB] transition-colors" />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900 mb-0.5">Single User Account</p>
            <p className="text-xs text-slate-500 leading-relaxed">
              I'm working independently. I'll manage my own leads and pipeline.
            </p>
          </div>
        </div>
      </button>

      <button
        onClick={() => onSelectType('organization')}
        className="w-full text-left p-4 border-2 border-slate-200 rounded-sm hover:border-[#0047AB] hover:bg-[#EFF6FF] transition-all group"
        data-testid="account-type-organization"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-slate-100 group-hover:bg-[#0047AB]/10 rounded-sm flex items-center justify-center shrink-0 transition-colors">
            <Building2 className="w-5 h-5 text-slate-600 group-hover:text-[#0047AB] transition-colors" />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900 mb-0.5">Organization Account</p>
            <p className="text-xs text-slate-500 leading-relaxed">
              I'm setting up a team. I'll be the admin and invite members to collaborate.
            </p>
          </div>
        </div>
      </button>
    </div>
  );
}
